import { useQuery } from '@apollo/client';

import { CompaniesByIndustryDocument } from '../../graphql/queries/companies-by-industry.gql-types';

type CompaniesByIndustriesProps = {
  limit: number;
  offset: number;
  id: string;
};

const useCompaniesByIndustry = ({
  limit = 4,
  offset = 0,
  id,
}: CompaniesByIndustriesProps) => {
  const variables = { limit, offset, id };
  const { error, ...rest } = useQuery(CompaniesByIndustryDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useCompaniesByIndustry };
